// extracted by mini-css-extract-plugin
export var container = "_cp-0";
export var icon = "_cp-1";
export var text = "_cp-2";